
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type headerMobileHomeVehicleWidgetRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function headerMobileHomeVehicleWidgetRT(): TemplateResult<headerMobileHomeVehicleWidgetRTRootProps> {
    function repeatSelects1(selects, selectsIndex) {
        return [selects(function () {
                function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n              ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n            ');
                }
                function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                    return _createElement('option', {
                        'disabled': this.loading,
                        'value': entry.term,
                        'key': entry.value
                    }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                }
                function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                    var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                    var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                    var isPopularField = popularEntries.length && unpopularEntries.length;
                    return [
                        !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                            'value': '',
                            'key': 'null-option'
                        }, '\n            ', _translate(`select_default_value`), '\n          ') : null,
                        this.loading ? _createElement('option', {
                            'key': 'loading-option',
                            'disabled': true
                        }, _translate(`select_loading`)) : null,
                        isPopularField ? [
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-popular',
                                'disabled': true,
                                'key': '10741'
                            }, _translate(`ymm_bar_popular`)),
                            _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                            _createElement('option', {
                                'className': 'cm_option_title cm_option-unpopular',
                                'disabled': true,
                                'key': '10744'
                            }, _translate(`ymm_bar_unpopular`))
                        ] : null,
                        _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                    ];
                }
                return _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                    'className': 'cm_select_toggle cm_select_toggle__native cm_toggle-dropdown',
                    'key': '44'
                }, _createElement('div', { 'className': 'cm_select_toggle-title' }, _translate(`select_title`), ' ', this.title), _createElement('select', {
                    'className': 'cm_select_inner-select cm_select__pretty',
                    'onChange': this.onChange,
                    'value': this.firstSelectedTerm || '',
                    'disabled': this.disabled,
                    'aria-label': this.title
                }, scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []))) : null);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__home cm_vehicle-widget__home-mobile cm_vehicle-widget__collapsible' }, this.template === 'active' ? _createElement('div', {
        'className': 'cmTemplate_active',
        'key': '120'
    }, _createElement('div', {
        'className': 'cm_vehicle-widget_header' + (this.collapsed ? ' cm_vehicle-widget_header-collapsed' : ''),
        'onClick': this.toggleCollapsed
    }, !this.isVehicleSelected ? _createElement('button', {
        'type': 'button',
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__select',
        'key': '360'
    }, '\n        ', _translate(`ymm_bar_home_no_selected`), '\n      ') : null, this.isVehicleSelected ? _createElement('div', {
        'className': 'cm_vehicle-widget_header-label-container',
        'key': '553'
    }, _createElement('span', { 'className': 'cm_vehicle-widget_header-label-title' }, 'YOUR VEHICLE:'), _createElement('span', { 'className': 'cm_vehicle-widget_header-label-vehicle' }, this.vehicleString)) : null, [_createElement('svg', {
            'width': '12',
            'height': '7',
            'viewBox': '0 0 12 7',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg',
            'key': '8270'
        }, _createElement('path', {
            'fillRule': 'evenodd',
            'clipRule': 'evenodd',
            'd': 'M11.4227 6.42267C11.0972 6.74811 10.5696 6.74811 10.2442 6.42267L5.83342 2.01193L1.42267 6.42267C1.09723 6.74811 0.569598 6.74811 0.244161 6.42267C-0.081275 6.09723 -0.0812751 5.5696 0.244161 5.24416L5.24416 0.244158C5.5696 -0.0812787 6.09723 -0.0812788 6.42267 0.244158L11.4227 5.24416C11.7481 5.5696 11.7481 6.09723 11.4227 6.42267Z',
            'fill': '#222222'
        }))]), _createElement('div', { 'className': 'cm_collapsible-elem' }, _createElement('div', { 'className': 'cm_vehicle-widget_dropdowns' }, _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
        'div',
        { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
        _map(this.selects, repeatSelects1.bind(this))
    ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go btn btn--primary',
        'onClick': () => {
            this.selectVehicle();
            if (this.name === 'HeaderVehicleWidget_mobile-menu') {
                window.document.querySelector('.close-mobile-nav.js-nav-control')?.click();
            }
        },
        'disabled': !this.allowToSetVehicle,
        'role': 'button'
    }, '\n    ', this.name === 'HeaderVehicleWidget' ? 'Search' : 'GO', '\n  '), _createElement('div', {
        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear btn btn--secondary',
        'onClick': this.discardVehicle,
        'disabled': !this.allowToDiscardVehicle,
        'role': 'button'
    }, '\n    ', this.name === 'HeaderVehicleWidget' ? 'Clear Filters' : 'Clear', '\n  '))), this.isVehicleSelected ? [
        _createElement('a', {
            'href': window.Convermax.Shopify.getSearchPageUrl(),
            'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__search btn btn--primary cm_desktop-hide',
            'role': 'button',
            'key': '55351'
        }, '\n            ', _translate(`ymm_bar_see_what_fits`), '\n          '),
        _createElement('div', {
            'className': 'cm_vehicle-widget_guarantee-label cm_desktop-hide',
            'key': '55353'
        }, _translate(`ymm_bar_guarantee`))
    ] : null))) : null);
}
        export const componentNames = []